/**
 * Dragonlord rule overrides.
 *
 * Card text (verbatim from sorcery-cards.json):
 *   "Before setup, set aside a Unique Dragon. Once on your turn, if
 *    you meet its threshold, you may pay (3) to gain its abilities
 *    this turn."
 *
 * The set-aside is NOT an activated ability. It happens exclusively
 * through the pre-game ceremony (`runDragonlordSetAsideSequence`,
 * interposed after the first-player roll-off, before the Harbinger
 * ceremony and the opening draws. Mirrors the Harbinger setup hook).
 * The picker offers every Unique Dragon the player OWNS ON THEIR
 * ACCOUNT (arena profile collection. Not the deck, not the in-game
 * Collection pile); the pick is remembered on the avatar
 * (`_dragonlordCompanion`) and the physical card never enters the
 * game.
 *
 * One activated built-in:
 *
 *   - Activate Dragon ability ((3), once per turn): gated on meeting
 *     the companion's printed threshold. Wears the Dragon's rules
 *     identity (cardId / subTypes / keywords / Movement+N / Ranged)
 *     for the turn via the imposterMask identity machinery while
 *     keeping Dragonlord's face; reverts at end of turn.
 *
 * Gate logic lives in `_canActivateEntry`'s `dragonlord_invoke`
 * branch; resolution in `avatarAbilities.resolveDragonlordInvoke`.
 * Pure helpers in `engine/automation/ops/dragonlord.js`.
 */
export const DRAGONLORD_RULES = {
  extraActivatedAbilities: [
    {
      id: '__builtin_dragonlord_invoke',
      trigger: 'activated',
      cost: [{ type: 'mana', amount: 3 }],
      once_per_turn: true,
      description: 'Activate Dragon ability',
      _builtin: 'dragonlord_invoke',
    },
  ],
};
